import { AdFileSize } from '@ligr/api-v2';
import { liveAndNotWaitingPriorityOne, screenNotEmpty, isLive } from '../../statements';
export const showScoreboard = {
    priority: 2,
    name: 'showScoreboard',
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        [
            'scoreboard',
            2,
            {
                preset: 'default',
                adLoop: true,
                liveLoop: true,
                adLoopSizes: [AdFileSize.small, AdFileSize.medium, AdFileSize.banner, AdFileSize.square]
            }
        ]
    ]
};
export const hideAll = {
    priority: 2,
    name: 'hideAll',
    transitions: [['action:hideAll', 0, { guard: screenNotEmpty }]]
};
export const teamMilestone = (_args, milestoneData) => ({
    priority: 4,
    name: 'teamMilestone',
    guard: isLive,
    transitions: [
        [
            'action:removeAllExcept',
            1,
            {
                toKeep: [
                    {
                        name: 'scoreboard',
                        graphicProps: Object.assign(Object.assign({ preset: 'teamStats', updateType: 'set' }, milestoneData), { adSizes: [AdFileSize.small, AdFileSize.medium, AdFileSize.banner, AdFileSize.square, AdFileSize.long] })
                    }
                ]
            }
        ],
        ['action:default', 12]
    ]
});
export const teamComparisonMilestone = (_args, milestoneData) => ({
    priority: 4,
    name: 'teamComparisonMilestone',
    guard: isLive,
    transitions: [
        ['action:default', 0],
        [
            'teamStatComparison',
            2,
            Object.assign(Object.assign({ updateType: 'update' }, milestoneData), { adSizes: [AdFileSize.small, AdFileSize.medium, AdFileSize.long] })
        ],
        ['action:default', 12]
    ]
});
/*export const playerMilestone: (args: SequenceTriggerArgs, milestoneData: any) => Sequence = (_args, milestoneData) => ({
  priority: 3,
  name: 'playerMilestone',
  transitions: [
    ['scoreboard', 0, {
      adSetTriggerEvent: 'playerStatMilestone',
      preset: 'player',
      ...milestoneData,
      adSizes: [
        AdFileSize.small,
        AdFileSize.medium,
        AdFileSize.banner,
        AdFileSize.square
      ]
    }],
    ['action:default', 10],
  ]
});*/
export const yellowCard = args => ({
    priority: 3,
    name: 'yellowCard',
    guard: isLive,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        [
            'event',
            2,
            {
                teamId: args.fact.teamId,
                playerId: args.fact.playerId,
                eventName: 'Yellow Card',
                adSetTriggerEvent: 'yellowCard',
                eventMinute: args.fact.minute,
                adSizes: [
                    AdFileSize.small,
                    AdFileSize.large,
                    AdFileSize.banner,
                    AdFileSize.square,
                    AdFileSize.long,
                    AdFileSize.medium
                ]
            }
        ],
        ['action:hideAll', 14],
        [
            'action:default',
            16,
            {
                guard: liveAndNotWaitingPriorityOne
            }
        ]
    ]
});
export const redCard = args => ({
    priority: 3,
    name: 'redCard',
    guard: isLive,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        [
            'event',
            2,
            {
                teamId: args.fact.teamId,
                playerId: args.fact.playerId,
                eventName: 'Red Card',
                eventMinute: args.fact.minute,
                adSetTriggerEvent: 'redCard',
                adSizes: [
                    AdFileSize.small,
                    AdFileSize.large,
                    AdFileSize.banner,
                    AdFileSize.square,
                    AdFileSize.long,
                    AdFileSize.medium
                ]
            }
        ],
        ['action:hideAll', 14],
        [
            'action:default',
            16,
            {
                guard: liveAndNotWaitingPriorityOne
            }
        ]
    ]
});
export const goal = args => ({
    priority: 1,
    name: 'goal',
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        [
            'event',
            2,
            {
                teamId: args.fact.teamId,
                factId: args.fact.id,
                playerId: args.fact.playerId,
                eventName: 'Goal',
                eventMinute: args.fact.minute,
                adSetTriggerEvent: 'goal',
                adSizes: [AdFileSize.xLarge, AdFileSize.large, AdFileSize.banner, AdFileSize.square, AdFileSize.long]
            }
        ],
        ['action:hideAll', 12],
        [
            'status',
            14,
            {
                guard: liveAndNotWaitingPriorityOne,
                adSetTriggerEvent: 'goal',
                adSizes: [AdFileSize.xLarge, AdFileSize.large, AdFileSize.long]
            }
        ],
        [
            'action:hideAll',
            22,
            {
                guard: liveAndNotWaitingPriorityOne
            }
        ],
        [
            'action:default',
            24,
            {
                guard: liveAndNotWaitingPriorityOne
            }
        ]
    ]
});
//# sourceMappingURL=live.js.map